import type { TemplateOnlyComponent } from '@ember/component/template-only';

const AccountActivityLoansLayout: TemplateOnlyComponent = <template>{{outlet}}</template>;
export default AccountActivityLoansLayout;
